/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "ISO8601Date": {
            "fields": {
              "dateString": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.ISO8601Date) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ISO8601Date @ squareup/client/date.proto at 14:1
 */
export const ISO8601Date = $root.lookupType('squareup.client.ISO8601Date');
fixType(ISO8601Date, {
  dateString: {
    required: true
  }
});
Builder.createAndAttachToType(ISO8601Date);